export const EXPRESSIONTEMPLATES_LOCALSTORAGE_KEY = 'expressiontemplates';

export const EXPRESSIONTEMPLATES_GENERATED = 'EXPRESSIONTEMPLATES_GENERATED';
